<template>
  <div class="home-main__container">
    <BaseImage
      v-if="image"
      :id="image"
      class="home-main__background"
    />
    <CarouselProducts
      v-if="products"
      :alert="alert"
      :products="products"
      class="HomeMission__carousel"
    />
    <HomeTicker
      v-if="ticker"
      :items="ticker.split('\n')"
    />
  </div>
</template>

<script>
  import HomeTicker from './HomeTicker';
  import CarouselProducts from './CarouselProducts';

  export default {
    components: {
      HomeTicker,
      CarouselProducts,
    },
    props: {
      alert: {
        type: String,
        default: null,
      },
      image: {
        type: [Number, Boolean],
        default: null,
      },
      ticker: {
        type: String,
        required: true,
      },
      products: {
        type: Array,
        default: null,
      },
    },
  };
</script>

<style
  lang="scss"
  scoped
>
  .home-main__container {
    position: relative;
    padding-top: spacing(base-zeta);
    padding-bottom: spacing(base-epsilon);

    @include breakpoint(phablet) {
      padding-top: 0;
      padding-bottom: spacing(base-zeta);
    }
  }

  .home-main__background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: grayscale(100%);
    background-color: color(slate);
  }

  .HomeMission__carousel {
    display: none;
    transform: translateY(spacing(base-zeta) * -1);
    position: relative;
    z-index: 15;

    @include breakpoint(phablet) {
      display: block;
    }
  }
</style>
